import getConfig from './config';

export { baseUrl, backendUrl, backendApi } from './config';

export default getConfig;
